import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Container from "react-bootstrap/esm/Container";
import LandingPage from "./screens/LandingPage/LandingPage";
import Dashboard from "./screens/LandingPage/Dashboard";
import LoginScreen from "./screens/LoginScreen/LoginScreen";
import ChangePassword from "./screens/LoginScreen/ChangePassword";
import RegisterScreen from "./screens/RegisterScreen/RegisterScreen";
import UnloadingEntry from "./screens/UnloadVehicle/UnloadingEntry";
// import NewUnloadingEntry from "./screens/UnloadVehicle/NewUnloadingEntry";
import NewUnloadingEntryQCScreen from "./screens/UnloadVehicle/NewUnloadingEntryQCScreen";

import ResetSuccess from "./screens/LoginScreen/ResetSuccess.js";
import ResetPasswd from "./screens/LoginScreen/ResetPasswd.js";

import ManageUSers from "./screens/User/ManageUsers";
import AssignRoles from "./screens/User/AssignRoles";

import AssignUnloadStations from "./screens/UnloadVehicle/AssignUnloadStations";
import VehicleTagIssue from "./screens/wbauto/VehicleTagIssue";
import ReWeighVehicle from "./screens/wbauto/ReWeighVehicle";
import RemoveStaledWbEntries from "./screens/wbauto/RemoveStaledWbEntries";
import MaintainCaptiveVehicle from "./screens/wbauto/MaintainCaptiveVehicle";
import TestCertificateStatus from "./screens/wbauto/TestCertificateStatus";
import WbController from "./screens/wbauto/WbController";
import EmptyGateOut from "./screens/wbauto/EmptyGateOut";
import AdjustToDispatch from "./screens/wbauto/AdjustToDispatch";

import SilcoBagWeight from "./screens/SilcoBagWeight/SilcoBagWeight";
import SilcoCaptiveBagWeight from "./screens/SilcoBagWeight/SilcoCaptiveBagWeight";

import MyUnloadedTrucksMobile from "./screens/UnloadVehicle/MyUnloadedTrucksMobile";
import MySlips from "./screens/UnloadVehicle/MySlips";

import FixUnloadLocationHOD from "./screens/UnloadVehicle/FixUnloadLocationHOD";
import QcRelease from "./screens/QC/QcRelease";

import LoadingEntry from "./screens/Loading/LoadingEntry.js";
import MyLoadedTrucks from "./screens/Loading/MyLoadedTrucks.jsx";
import LoadingAdviceQCScreen from "./screens/Loading/LoadingAdviceQCScreen.js";
import { selectUser, setUser } from "./features/userSlice";
import MaterialChange from "./screens/wbauto/MaterialChange.js";
import PublicRoute from "./routes/PublicRoute.jsx";
import ProtectedRoute from "./routes/ProtectedRoute.jsx";
import MyLoadingSlips from "./screens/Loading/MyLoadingSlips.jsx";
import UpdateTestCertificate from "./screens/Loading/UpdateTestCertificate.jsx";

const FULL_BLEED_PATHS = ["/", "/login", "/resetPassword", "/resetSuccess"];
const WIDE_SHELL_PATHS = ["/dashboard", "/Dashboard", "/change-password"];

function AppRoutes() {
  const location = useLocation();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const path = location.pathname;
  const isFullBleed = FULL_BLEED_PATHS.includes(path);
  const isWideShell = WIDE_SHELL_PATHS.includes(path);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      try {
        const user = await localStorage.getItem("SEPL_LOGISTICS_USER");

        if (user) {
          dispatch(setUser({ ...JSON.parse(user) }))
        }
      } catch (err) {
        // console.log(err);
      } finally {
        setLoading(false);
      }
    };

    initialize();
  }, []);

  const routes = (
    <Routes>
      <Route element={<PublicRoute user={user} redirectTo="/dashboard" />}>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
      </Route>

      {/* Protected routes - all routes inside Layout are protected */}
      <Route element={<ProtectedRoute user={user} />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/manageUsers" element={<ManageUSers />} />
        <Route path="/AssignRoles" element={<AssignRoles />} />
        <Route path="/UnloadingEntry" element={<UnloadingEntry />} />
        {/* <Route path="/NewUnloadingEntry" element={<NewUnloadingEntry />} /> */}
        <Route path="/NewUnloadingEntryQCScreen" element={<NewUnloadingEntryQCScreen />} />
        <Route path="/assignUnloadStations" element={<AssignUnloadStations />} />
        <Route path="/VehicleTagIssue" element={<VehicleTagIssue />} />
        <Route path="/ReWeighVehicle" element={<ReWeighVehicle />} />
        {/* <Route path="/materialChange" element={<MaterialChange />} /> */}
        <Route path="/SilcoBagWeight" element={<SilcoBagWeight />} />
        <Route path="/SilcoCaptiveBagWeight" element={<SilcoCaptiveBagWeight />} />
        <Route path="/MyUnloadedTrucksMobile" element={<MyUnloadedTrucksMobile />} />
        <Route path="/FixUnloadLocationHOD" element={<FixUnloadLocationHOD />} />
        <Route path="/QcRelease" element={<QcRelease />} />
        <Route path="/myslips" element={<MySlips />} />
        <Route path="/loading-entry" element={<LoadingEntry />} />
        <Route path="/my-loaded-trucks" element={<MyLoadedTrucks />} />
        <Route path="/my-loading-slips" element={<MyLoadingSlips />} />
        <Route path="/remove-staled-wb" element={<RemoveStaledWbEntries />} />
        <Route path="/maintain-captive-vehicle" element={<MaintainCaptiveVehicle />} />
        <Route path="/test-certificate-status" element={<TestCertificateStatus />} />
        <Route path="/wb-controller" element={<WbController />} />
        <Route path="/empty-gate-out" element={<EmptyGateOut />} />
        <Route path="/adjust-to-challan" element={<AdjustToDispatch />} />
        <Route path="/loading-advice-qc" element={<LoadingAdviceQCScreen />} />
        <Route path="/update-test-certificate" element={<UpdateTestCertificate />} />
      </Route>

      {/* Shared routes */}
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/resetSuccess" element={<ResetSuccess />} />
      <Route path="/resetPassword" element={<ResetPasswd />} />
    </Routes>
  );

  if (loading) {
    return (
      <div style={{ height: "100vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f8f9fa" }}>
        <div style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>Loading...</div>
      </div>
    )
  }

  if (isFullBleed) {
    return <main className="app-fullbleed">{routes}</main>;
  }

  if (isWideShell) {
    return (
      <main className="app-wide-shell">
        {routes}
        {user ? <Footer /> : null}
      </main>
    );
  }

  return (
    <Container>
      <main>{routes}</main>
      {user ? <Footer /> : null}
    </Container>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
